<template>
  <span v-if="isPointOfSale" class="point-of-sale-tag">Punto de Venta</span>
</template>

<script>
import { acceptsCashOnDelivery } from '@/utils/scharffPoint'

export default {
  props: {
    point: { required: false, default: null },
  },
  computed: {
    isPointOfSale() {
      return acceptsCashOnDelivery(this.point)
    },
  },
}
</script>

<style lang="scss" scoped>
.point-of-sale-tag {
  display: inline-block;
  align-self: flex-start;
  width: fit-content;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  white-space: nowrap;
  /* Same green as the POS badge for this tag. */
  background: #DCFCE7;
  color: #166534;
}
</style>
